



















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import DiameterConfig from '@/models/dackpartner/DiameterConfig'

@Component
export default class DiameterTable extends Vue {
  @Prop({ default: false }) readonly!: boolean
  @Prop({ default: '' }) suffix!: string
  @Prop({ default: () => [] }) rules!: Array<(v: any) => boolean | string>
  @Prop({ default: () => [] }) diameterConfig!: DiameterConfig
}
